import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { FolioFactura } from "app/features/componentes/foliofactura";
import { SelectorSimpleFactory } from "app/features/selectores/logic";

export interface Props {
    value: models.FiltroFacturas;
    onChange: (value: models.FiltroFacturas) => void;
}

const LimiteFacturas = SelectorSimpleFactory([25, 50, 100, 200, 500, 1000, 2000], x => x, x => "" + x);

/**
* Componente para editar un FiltroGuia
*/
export class FiltroFacturaComponent extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<models.FiltroFacturas> {
        return {};
    }


    /**
     Establece la hora desde a la primer hora del día 12:00 am
     */
    private onFechaDesdeChange = (x: Date | null) => {
        if (x) {
            var fecha = new Date(x);
            fecha.setHours(0, 0, 0, 0);
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroFacturas> = { FechaInicio: fecha };
            this.props.onChange({ ...viejo, ...cambioFecha });
        } else {
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroFacturas> = { FechaInicio: null };
            this.props.onChange({ ...viejo, ...cambioFecha });
        }
    }

    /**
    Establece la hora hasta a la ultima hora del día 11:59 pm
    */
    private onFechaHastaChange = (x: Date | null) => {
        if (x) {
            var fecha = new Date(x);
            fecha.setHours(23, 59, 59);
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroFacturas> = { FechaFinal: fecha };
            this.props.onChange({ ...viejo, ...cambioFecha });
        } else {
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroFacturas> = { FechaFinal: null };
            this.props.onChange({ ...viejo, ...cambioFecha });
        }
    }

    private onFechaCancelDesdeChange = (x: Date | null) => {
        if (x) {
            var fecha = new Date(x);
            fecha.setHours(0, 0, 0, 0);
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroFacturas> = { FechaCancelacionInicio: fecha };
            this.props.onChange({ ...viejo, ...cambioFecha });
        } else {
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroFacturas> = { FechaCancelacionInicio: null };
            this.props.onChange({ ...viejo, ...cambioFecha });
        }
    }

    private onFechaCancelHastaChange = (x: Date | null) => {
        if (x) {
            var fecha = new Date(x);
            fecha.setHours(23, 59, 59);
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroFacturas> = { FechaCancelacionFinal: fecha };
            this.props.onChange({ ...viejo, ...cambioFecha });
        } else {
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroFacturas> = { FechaCancelacionFinal: null };
            this.props.onChange({ ...viejo, ...cambioFecha });
        }
    }

    render() {
        const { value } = this.props;
        const getField = this.getField;

        const Datetime = getField(kea.DateTime);
        const Cliente = getField(selectores.Cliente);
        const Sucursal = getField(selectores.Sucursal);
        const Origen = getField(selectores.OrigenFactura);
        const Folio = getField(FolioFactura);
        const SiNo = getField(selectores.SiNo);
        const EmpresaLogistica = getField(selectores.EmpresaLogistica);
        const Limite = getField(LimiteFacturas);

        return (
            <div>
                {kea.autogrid(2, [
                    <Datetime field="FechaInicio" label="Fecha de creación (inicio):" onChange={this.onFechaDesdeChange} />,
                    <Datetime field="FechaFinal" label="Fecha de creación (final):" onChange={this.onFechaHastaChange} />,
                    <Folio field="SerieFolio" />,
                    <Sucursal field="IdSucursal" label="Sucursal:" />,
                    <Cliente field="IdCliente" label="Cliente:" />,
                    <Origen field="Origen" label="Origen:" />,
                    <SiNo field="EsNotaCredito" label="Nota de crédito" />,
                    <SiNo field="EsNotaCargo" label="Nota de cargo" />,
                    <SiNo field="EsTimbrada" label="Timbrada" />,
                    <SiNo field="EsCancelada" label="Cancelada" />,
                    <SiNo field="DeCredito" label="De crédito" />,
                    <Limite field="Limite" label="Limite" />,
                    <Datetime field="FechaCancelacionInicio" label="Fecha de cancelación (inicio):" onChange={this.onFechaCancelDesdeChange} />,
                    <Datetime field="FechaCancelacionFinal" label="Fecha de cancelación (final):" onChange={this.onFechaCancelHastaChange} />,
                    <EmpresaLogistica field="EsFacturaLogistica" label="Empresa" />,
                ])}
            </div>);
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/list/filtro.tsx